/*
 * @Author: ken yang
 * @Date: 2022-09-07 09:21:36
 * @LastEditTime: 2025-06-18 18:27:55
 * @LastEditors: ken yang
 * @Description: map的store
 * @FilePath: /uexch_pc/src/store/map.js
 */
import { defineStore } from 'pinia'
import { nextTick } from 'vue'

const useMapStore = defineStore('mapStore', {
  state: () => {
    return {
      coinList: [],
    }
  },
  getters: {
    getCoinByName: (state) => {
      return (name) => {
        return state.coinList.find(e => e.coinName === name)
      }
    },
    getCoinById: (state) => {
      return (coinId) => {
        return state.coinList.find(e => e.coinId === coinId)
      }
    },

  },
  actions: {
    async getCoinList () {
      return
      try {
        const data = await walletApi.commonCoinList()
        this.$patch(state => {
          state.coinList = data
        })
      } catch (error) {
        console.log(walletApi.transferCoinList, error)
      }
    },
  },
  init () {
    this.getCoinList()
  },
})

export default useMapStore
